/**
 * Allowance Settings Type Enum
 * Defines the types of allowance settings (Charter or Contract)
 */
export const AllowanceSettingType = {
  CHARTER: 'CHARTER',
  CONTRACT: 'CONTRACT',
};

/**
 * Allowance Settings Code Enum
 * Defines all available allowance codes for both Charter and Contract types
 */
export const AllowanceSettingCode = {
  // Charter Allowances
  TRIP_ALLOWANCE: 'TRIP_ALLOWANCE',
  DEADHEAD_ALLOWANCE: 'DEADHEAD_ALLOWANCE',
  '2_SERVICE_ALLOWANCE': '2_SERVICE_ALLOWANCE',
  REST_DAYS_ALLOWANCE: 'REST_DAYS_ALLOWANCE',
  ATTENDANCE_ALLOWANCE: 'ATTENDANCE_ALLOWANCE',

};

/**
 * Allowance Status Enum
 * Defines the possible status values for allowances
 */
export const AllowanceStatus = {
  ENABLED: true,
  DISABLED: false,
};

export default {
  AllowanceSettingType,
  AllowanceSettingCode,
  AllowanceStatus,
};
